import React, { useState, useEffect } from 'react';
import { TextField, List, ListItem, ListItemText, ListItemAvatar, Avatar, Typography, Box  ,   Checkbox, 
    IconButton, ListItemIcon} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ImageIcon from '@mui/icons-material/Image';
import DeleteIcon from '@mui/icons-material/Delete';
import {ReactComponent as Search} from '../Layer_images/Settings_images/search.svg';



const MainSearchBar = ({ search, search_loc, searchterm, sendingnew, searchBar, showResults, searchBarGetBrand, customBrandSearch }) => {
    // data-tut="reactour__search"  type="text" className="search-results-total" placeholder="Search..." onChange={e => search_loc(e.target.value, true) } value={searchterm}
    return (
    <>
        <div  className={`prospect-search-total ${searchBar ? "transform-show" : 'Building-total-hideval'}`} > 
            <div >
                <div className="prospect-background">
                    <div className="prospect-searchbar-total">
                        <Search className='main-filter-image' />
                        <input className="prospect-searchbar w-368"  onChange={e => search_loc(e.target.value, true) }  placeholder='Search for addresses or brands' value={searchterm}></input>
                    </div>
                </div>
            </div>
                            {/* <TextField
            data-tut="reactour__search"
            fullWidth
            variant="outlined"
            placeholder="Search..."
            onChange={(e) => search_loc(e.target.value)}
            value={searchterm}
            InputProps={{
                endAdornment: <SearchIcon />,
            }}
            sx={{ m: 1 }}
            /> */}
            {search.length > 0 && <List sx={{  width: '100%', 
                maxHeight: 300, 
                zIndex: 3,
                overflow: 'auto',
                backgroundColor: 'white', // Make background white
                boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
                marginTop: '-5px'
                 }}>
                {search.map((item) => (
                    <ListItem
                        key={item.id}
                        alignItems="flex-start"
                        onClick={() => sendingnew(item.position, item.title, item.subcategory, item.image, item.single, item)}
                        sx={{ 
                            cursor: 'pointer', 
                            zIndex: 3,
                            '&:hover': { 
                                bgcolor: 'rgba(0, 0, 0, 0.04)', 
                                cursor: 'pointer'
                            },
                        }}
                    >
                        {item.image && <Box
                            sx={{
                                width: 32,
                                height: 32,
                                marginRight: 1,
                                marginTop: '10px',
                                overflow: 'hidden',
                            }}
                        >
                            <img 
                                src={item.image} 
                                alt={item.title}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                }}
                            />
                        </Box>}
                        <ListItemText
                            primary={item.title}
                            secondary={
                                <>
                                    <Typography
                                        sx={{ display: 'inline' }}
                                        component="span"
                                        variant="body2"
                                        color="text.primary"
                                    >
                                        {item.subcategory}
                                    </Typography>
                                </>
                            }
                        />
                    </ListItem>
                ))}
            </List>}
            



            <div className='custom-search-main'>
              {customBrandSearch.map((item, index) => {
                const labelId = `checkbox-list-label-${index}`;

                return (
                  <ListItem
                    key={index}
                    secondaryAction={
                      <IconButton edge="end" aria-label="delete" onClick={() => searchBarGetBrand({title: item.Name_final, subcategory: item.subcategory}, true)}>
                        <DeleteIcon />
                      </IconButton>
                    }
                    disablePadding
                  >
                    <ListItemIcon sx={{minWidth: 0}}>
                      <Checkbox
                        onChange={() => searchBarGetBrand({title: item.Name_final, subcategory: item.subcategory, status: !item.status}, false, true)}
                        edge="start"
                        checked={item.status || false}
                        sx={{
                          color: 'grey.500',
                          '&.Mui-checked': {
                            color: 'light-blue',
                          },
                        }}
                      />
                    </ListItemIcon>
                    {item.Image && (
                      <Box
                        component="img"
                        sx={{
                          width: 20,
                          height: 20,
                          marginRight: 1,
                          objectFit: 'contain',
                        }}
                        src={item.Image}
                        alt={item.Name_final}
                      />
                    )}
                    <ListItemText 
                      id={labelId} 
                      primary={
                        <Typography variant="body1" style={{ fontSize: '15px', fontColor: item.status ? 'light-blue' : 'grey.500', fontWeight: item.status ? 'bold' : 'normal' }}>
                          {item.Name_final}
                        </Typography>
                      }
                    />
                  </ListItem>
                );
              })}
          </div>
            
            </div>
    </>
    );
};




export default MainSearchBar;